var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "information" } },
    [
      _c(
        "v-list",
        {
          staticClass: "information-content d-flex justify-center flex-wrap",
          attrs: { dense: "" }
        },
        _vm._l(_vm.information, function(item, i) {
          return _c(
            "v-list-item",
            {
              key: i,
              staticClass: "information-content__wrapper d-flex align-center"
            },
            [
              _c("v-icon", { attrs: { color: item.color, large: "" } }, [
                _vm._v(
                  "\n                " + _vm._s(item.icon) + "\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", {
                    staticClass:
                      "information-content__title information-content__text",
                    domProps: { textContent: _vm._s(item.title) }
                  }),
                  _vm._v(" "),
                  _c("v-list-item-subtitle", {
                    staticClass:
                      "information-content__subtitle information-content__text",
                    domProps: { textContent: _vm._s(item.content) }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }